(() => {
  const init = () => {
    document.querySelectorAll('.nbh-predictive').forEach((root) => {
      if (root.dataset.nbhSearchReady === 'true') return;
      root.dataset.nbhSearchReady = 'true';
      const input = root.querySelector('input[type="search"]');
      const empty = root.querySelector('[data-nbh-search-empty]');
      const results = root.querySelector('[data-predictive-search]');
      if (!input || !empty) return;

      const sync = () => {
        const hasValue = input.value.trim().length > 0;
        root.classList.toggle('is-empty-open', !hasValue && document.activeElement === input);
      };

      input.addEventListener('focus', sync);
      input.addEventListener('input', () => {
        root.classList.remove('is-results-open');
        sync();
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') root.classList.remove('is-empty-open');
      });

      if (results && 'MutationObserver' in window) {
        new MutationObserver(() => {
          const populated = results.textContent.trim().length > 0 && input.value.trim().length > 0;
          root.classList.toggle('is-results-open', populated);
          if (populated) root.classList.remove('is-empty-open');
        }).observe(results, { childList: true, subtree: true });
      }

      document.addEventListener('pointerdown', (event) => {
        if (!root.contains(event.target)) root.classList.remove('is-empty-open');
      });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
